"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoQueryRequiredKeys = exports.PhysicalInformationFilters = exports.KpiRetailQueryTargetPassageType = exports.KpiRetailQueryTarget = exports.FilterOperators = exports.ConditionOperators = exports.ConditionCriterions = exports.Month = exports.Weekdays = exports.GroupByGranularities = exports.KpiRetailGroupType = exports.RetailMetrics = exports.GroupSizes = exports.Engagements = void 0;
var Engagements;
(function (Engagements) {
    Engagements["ALL"] = "ALL";
    Engagements["NOT_ENGAGED"] = "NOT_ENGAGED";
    Engagements["ENGAGED"] = "ENGAGED";
})(Engagements = exports.Engagements || (exports.Engagements = {}));
var GroupSizes;
(function (GroupSizes) {
    GroupSizes["ALL"] = "ALL";
    GroupSizes["EQ_1"] = "EQ_1";
    GroupSizes["GT_1"] = "GT_1";
})(GroupSizes = exports.GroupSizes || (exports.GroupSizes = {}));
var RetailMetrics;
(function (RetailMetrics) {
    // Zones
    RetailMetrics["DWELL"] = "DWELL";
    RetailMetrics["CAPTURE_RATE"] = "CAPTURE_RATE";
    RetailMetrics["POPULARITY"] = "POPULARITY";
    RetailMetrics["AFFLUENCE_IN"] = "AFFLUENCE_IN";
    RetailMetrics["AFFLUENCE_OUT"] = "AFFLUENCE_OUT";
    RetailMetrics["INSIDE"] = "INSIDE";
    RetailMetrics["GROUP_SIZE_IN"] = "GROUP_SIZE_IN";
    RetailMetrics["GROUP_SIZE_OUT"] = "GROUP_SIZE_OUT";
    RetailMetrics["N_GROUPS_IN"] = "N_GROUPS_IN";
    RetailMetrics["N_GROUPS_OUT"] = "N_GROUPS_OUT";
    RetailMetrics["WAITING_TIME"] = "WAITING_TIME";
    // Zone With limit
    RetailMetrics["OCCUPANCY"] = "OCCUPANCY";
    RetailMetrics["BINARY_OCCUPANCY"] = "BINARY_OCCUPANCY";
    RetailMetrics["AFFLUENCE_IN_QUEUE"] = "AFFLUENCE_IN_QUEUE";
    // Zone Queue
    RetailMetrics["AFFLUENCE_OUT_QUEUE"] = "AFFLUENCE_OUT_QUEUE";
    RetailMetrics["INSIDE_QUEUE"] = "INSIDE_QUEUE";
    RetailMetrics["DWELL_QUEUE"] = "DWELL_QUEUE";
    RetailMetrics["ABANDON_RATE_QUEUE"] = "ABANDON_RATE_QUEUE";
    RetailMetrics["GROUP_PERCENTAGE"] = "GROUP_PERCENTAGE";
    RetailMetrics["OCCUPANCY_STATUS"] = "OCCUPANCY_STATUS";
    RetailMetrics["DEVICE_STATUS"] = "DEVICE_STATUS";
    RetailMetrics["DENSITY"] = "DENSITY";
    RetailMetrics["REVERSE_DENSITY"] = "REVERSE_DENSITY";
    // Not really a metric, only temporary measure for the live widget
    RetailMetrics["LIMIT"] = "LIMIT";
    // Air Quality
    RetailMetrics["HUMIDITY_LEVEL"] = "HUMIDITY_LEVEL";
    RetailMetrics["CO2_LEVEL"] = "CO2_LEVEL";
    RetailMetrics["TEMPERATURE"] = "TEMPERATURE";
    RetailMetrics["TVOC"] = "TVOC";
    RetailMetrics["PM2_5_LEVEL"] = "PM2_5_LEVEL";
    RetailMetrics["PM10_LEVEL"] = "PM10_LEVEL";
    RetailMetrics["LUMINOSITY"] = "LUMINOSITY";
    RetailMetrics["PRESSURE"] = "PRESSURE";
    // Scoring
    RetailMetrics["COMFORT_SCORE"] = "COMFORT_SCORE";
    RetailMetrics["CO2_LEVEL_SCORE"] = "CO2_LEVEL_SCORE";
    RetailMetrics["HUMIDITY_LEVEL_SCORE"] = "HUMIDITY_LEVEL_SCORE";
    RetailMetrics["TEMPERATURE_SCORE"] = "TEMPERATURE_SCORE";
    RetailMetrics["TVOC_SCORE"] = "TVOC_SCORE";
    RetailMetrics["PM2_5_LEVEL_SCORE"] = "PM2_5_LEVEL_SCORE";
    RetailMetrics["PM10_LEVEL_SCORE"] = "PM10_LEVEL_SCORE";
    RetailMetrics["LUMINOSITY_SCORE"] = "LUMINOSITY_SCORE";
    RetailMetrics["PRESSURE_SCORE"] = "PRESSURE_SCORE";
    // Electricity
    RetailMetrics["ELECTRICITY_PRODUCTION"] = "ELECTRICITY_PRODUCTION";
    RetailMetrics["ELECTRICITY_CONSUMPTION"] = "ELECTRICITY_CONSUMPTION";
    RetailMetrics["ELECTRICITY_PRODUCTION_PER_SQM"] = "ELECTRICITY_PRODUCTION_PER_SQM";
    RetailMetrics["ELECTRICITY_PRODUCTION_ENERGY_EQ"] = "ELECTRICITY_PRODUCTION_ENERGY_EQ";
    RetailMetrics["ELECTRICITY_PRODUCTION_ENERGY_EQ_PER_SQM"] = "ELECTRICITY_PRODUCTION_ENERGY_EQ_PER_SQM";
    RetailMetrics["ELECTRICITY_PRODUCTION_CO2_EQ"] = "ELECTRICITY_PRODUCTION_CO2_EQ";
    RetailMetrics["ELECTRICITY_PRODUCTION_CO2_EQ_PER_SQM"] = "ELECTRICITY_PRODUCTION_CO2_EQ_PER_SQM";
    RetailMetrics["ELECTRICITY_CONSUMPTION_PER_SQM"] = "ELECTRICITY_CONSUMPTION_PER_SQM";
    RetailMetrics["ELECTRICITY_CONSUMPTION_ENERGY_EQ"] = "ELECTRICITY_CONSUMPTION_ENERGY_EQ";
    RetailMetrics["ELECTRICITY_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "ELECTRICITY_CONSUMPTION_ENERGY_EQ_PER_SQM";
    RetailMetrics["ELECTRICITY_CONSUMPTION_CO2_EQ"] = "ELECTRICITY_CONSUMPTION_CO2_EQ";
    RetailMetrics["ELECTRICITY_CONSUMPTION_CO2_EQ_PER_SQM"] = "ELECTRICITY_CONSUMPTION_CO2_EQ_PER_SQM";
    // Water
    RetailMetrics["WATER_CONSUMPTION"] = "WATER_CONSUMPTION";
    RetailMetrics["WATER_CONSUMPTION_PER_SQM"] = "WATER_CONSUMPTION_PER_SQM";
    RetailMetrics["WATER_CONSUMPTION_ENERGY_EQ"] = "WATER_CONSUMPTION_ENERGY_EQ";
    RetailMetrics["WATER_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "WATER_CONSUMPTION_ENERGY_EQ_PER_SQM";
    RetailMetrics["WATER_CONSUMPTION_CO2_EQ"] = "WATER_CONSUMPTION_CO2_EQ";
    RetailMetrics["WATER_CONSUMPTION_CO2_EQ_PER_SQM"] = "WATER_CONSUMPTION_CO2_EQ_PER_SQM";
    // Combustible
    RetailMetrics["COMBUSTIBLE_CONSUMPTION"] = "COMBUSTIBLE_CONSUMPTION";
    RetailMetrics["COMBUSTIBLE_CONSUMPTION_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_PER_SQM";
    RetailMetrics["COMBUSTIBLE_CONSUMPTION_ENERGY_EQ"] = "COMBUSTIBLE_CONSUMPTION_ENERGY_EQ";
    RetailMetrics["COMBUSTIBLE_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_ENERGY_EQ_PER_SQM";
    RetailMetrics["COMBUSTIBLE_CONSUMPTION_CO2_EQ"] = "COMBUSTIBLE_CONSUMPTION_CO2_EQ";
    RetailMetrics["COMBUSTIBLE_CONSUMPTION_CO2_EQ_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_CO2_EQ_PER_SQM";
})(RetailMetrics = exports.RetailMetrics || (exports.RetailMetrics = {}));
var KpiRetailGroupType;
(function (KpiRetailGroupType) {
    KpiRetailGroupType["DATE"] = "DATE";
    KpiRetailGroupType["DEVICE"] = "DEVICE";
    KpiRetailGroupType["TAG_CATEGORY"] = "TAG_CATEGORY";
    KpiRetailGroupType["TAG"] = "TAG";
    KpiRetailGroupType["ZONE"] = "ZONE";
    KpiRetailGroupType["ALL"] = "ALL";
    KpiRetailGroupType["GENDER"] = "GENDER";
    KpiRetailGroupType["PASSAGE"] = "PASSAGE";
    KpiRetailGroupType["ZONE_ID"] = "ZONE_ID";
    KpiRetailGroupType["ENGAGEMENT"] = "ENGAGEMENT";
    KpiRetailGroupType["GROUP_SIZE"] = "GROUP_SIZE";
    KpiRetailGroupType["AFFLUENCE_IN"] = "AFFLUENCE_IN";
    KpiRetailGroupType["DISCONTINUOUS_DATE"] = "DISCONTINUOUS_DATE";
    KpiRetailGroupType["AGE_CATEGORY"] = "AGE_CATEGORY";
    KpiRetailGroupType["LIMIT"] = "LIMIT";
    KpiRetailGroupType["ELEC_ORIGIN"] = "ELEC_ORIGIN";
    KpiRetailGroupType["ELEC_DESTINATION"] = "ELEC_DESTINATION";
    KpiRetailGroupType["COMBUSTIBLE_TYPE"] = "COMBUSTIBLE_TYPE";
    KpiRetailGroupType["WATER_TEMPERATURE"] = "WATER_TEMPERATURE";
    KpiRetailGroupType["ELEC_USE"] = "ELEC_USE";
    KpiRetailGroupType["WATER_USE"] = "WATER_USE";
    KpiRetailGroupType["COMBUSTIBLE_USE"] = "COMBUSTIBLE_USE";
})(KpiRetailGroupType = exports.KpiRetailGroupType || (exports.KpiRetailGroupType = {}));
var GroupByGranularities;
(function (GroupByGranularities) {
    GroupByGranularities["MINUTELY"] = "MINUTELY";
    GroupByGranularities["HOURLY"] = "HOURLY";
    GroupByGranularities["DAILY"] = "DAILY";
    GroupByGranularities["WEEKDAY"] = "WEEKDAY";
    GroupByGranularities["WEEKEND"] = "WEEKEND";
    GroupByGranularities["WEEKLY"] = "WEEKLY";
    GroupByGranularities["MONTHLY"] = "MONTHLY";
})(GroupByGranularities = exports.GroupByGranularities || (exports.GroupByGranularities = {}));
var Weekdays;
(function (Weekdays) {
    Weekdays["MONDAY"] = "monday";
    Weekdays["TUESDAY"] = "tuesday";
    Weekdays["WEDNESDAY"] = "wednesday";
    Weekdays["THURSDAY"] = "thursday";
    Weekdays["FRIDAY"] = "friday";
    Weekdays["SATURDAY"] = "saturday";
    Weekdays["SUNDAY"] = "sunday";
})(Weekdays = exports.Weekdays || (exports.Weekdays = {}));
var Month;
(function (Month) {
    Month["JANUARY"] = "January";
    Month["FEBRUARY"] = "February";
    Month["MARCH"] = "March";
    Month["APRIL"] = "April";
    Month["MAY"] = "May";
    Month["JUNE"] = "June";
    Month["JULY"] = "July";
    Month["AUGUST"] = "August";
    Month["SEPTEMBER"] = "September";
    Month["OCTOBER"] = "October";
    Month["NOVEMBER"] = "November";
    Month["DECEMBER"] = "December";
})(Month = exports.Month || (exports.Month = {}));
var ConditionCriterions;
(function (ConditionCriterions) {
    ConditionCriterions["DATE"] = "DATE";
    ConditionCriterions["DAY"] = "DAY";
    ConditionCriterions["TIME"] = "TIME";
    ConditionCriterions["LAST_N_DAYS"] = "LAST_N_DAYS";
    ConditionCriterions["TAGS"] = "TAGS";
    ConditionCriterions["TAG_CATEGORIES"] = "TAG_CATEGORIES";
    ConditionCriterions["CITY"] = "CITY";
    ConditionCriterions["COUNTRY"] = "COUNTRY";
    ConditionCriterions["ENGAGEMENTS"] = "ENGAGEMENTS";
    ConditionCriterions["GROUP_SIZES"] = "GROUP_SIZES";
    ConditionCriterions["GENDERS"] = "GENDERS";
    ConditionCriterions["AGE_CATEGORY"] = "AGE_CATEGORY";
    ConditionCriterions["PASSAGES"] = "PASSAGES";
    ConditionCriterions["ZONES"] = "ZONES";
    ConditionCriterions["DEVICES"] = "DEVICES";
    ConditionCriterions["AFFLUENCE_IN"] = "AFFLUENCE_IN";
    ConditionCriterions["AFFLUENCE_OUT"] = "AFFLUENCE_OUT";
    ConditionCriterions["DWELL"] = "DWELL";
    ConditionCriterions["CAPTURE_RATE"] = "CAPTURE_RATE";
    ConditionCriterions["POPULARITY"] = "POPULARITY";
    ConditionCriterions["INSIDE"] = "INSIDE";
    ConditionCriterions["GROUP_SIZE_IN"] = "GROUP_SIZE_IN";
    ConditionCriterions["GROUP_SIZE_OUT"] = "GROUP_SIZE_OUT";
    ConditionCriterions["N_GROUPS_IN"] = "N_GROUPS_IN";
    ConditionCriterions["N_GROUPS_OUT"] = "N_GROUPS_OUT";
    ConditionCriterions["OCCUPANCY"] = "OCCUPANCY";
    ConditionCriterions["AFFLUENCE_IN_QUEUE"] = "AFFLUENCE_IN_QUEUE";
    ConditionCriterions["AFFLUENCE_OUT_QUEUE"] = "AFFLUENCE_OUT_QUEUE";
    ConditionCriterions["INSIDE_QUEUE"] = "INSIDE_QUEUE";
    ConditionCriterions["DWELL_QUEUE"] = "DWELL_QUEUE";
    ConditionCriterions["ABANDON_RATE_QUEUE"] = "ABANDON_RATE_QUEUE";
    ConditionCriterions["HUMIDITY_LEVEL"] = "HUMIDITY_LEVEL";
    ConditionCriterions["CO2_LEVEL"] = "CO2_LEVEL";
    ConditionCriterions["TEMPERATURE"] = "TEMPERATURE";
    ConditionCriterions["ALERT"] = "ALERT";
    ConditionCriterions["TVOC"] = "TVOC";
    ConditionCriterions["PM2_5_LEVEL"] = "PM2_5_LEVEL";
    ConditionCriterions["PM10_LEVEL"] = "PM10_LEVEL";
    ConditionCriterions["LUMINOSITY"] = "LUMINOSITY";
    ConditionCriterions["PRESSURE"] = "PRESSURE";
    ConditionCriterions["COMFORT_SCORE"] = "COMFORT_SCORE";
    ConditionCriterions["CO2_LEVEL_SCORE"] = "CO2_LEVEL_SCORE";
    ConditionCriterions["HUMIDITY_LEVEL_SCORE"] = "HUMIDITY_LEVEL_SCORE";
    ConditionCriterions["TEMPERATURE_SCORE"] = "TEMPERATURE_SCORE";
    ConditionCriterions["TVOC_SCORE"] = "TVOC_SCORE";
    ConditionCriterions["PM2_5_LEVEL_SCORE"] = "PM2_5_LEVEL_SCORE";
    ConditionCriterions["PM10_LEVEL_SCORE"] = "PM10_LEVEL_SCORE";
    ConditionCriterions["LUMINOSITY_SCORE"] = "LUMINOSITY_SCORE";
    ConditionCriterions["PRESSURE_SCORE"] = "PRESSURE_SCORE";
    ConditionCriterions["ELECTRICITY_PRODUCTION"] = "ELECTRICITY_PRODUCTION";
    ConditionCriterions["ELECTRICITY_CONSUMPTION"] = "ELECTRICITY_CONSUMPTION";
    ConditionCriterions["ELECTRICITY_PRODUCTION_PER_SQM"] = "ELECTRICITY_PRODUCTION_PER_SQM";
    ConditionCriterions["ELECTRICITY_PRODUCTION_ENERGY_EQ"] = "ELECTRICITY_PRODUCTION_ENERGY_EQ";
    ConditionCriterions["ELECTRICITY_PRODUCTION_ENERGY_EQ_PER_SQM"] = "ELECTRICITY_PRODUCTION_ENERGY_EQ_PER_SQM";
    ConditionCriterions["ELECTRICITY_PRODUCTION_CO2_EQ"] = "ELECTRICITY_PRODUCTION_CO2_EQ";
    ConditionCriterions["ELECTRICITY_PRODUCTION_CO2_EQ_PER_SQM"] = "ELECTRICITY_PRODUCTION_CO2_EQ_PER_SQM";
    ConditionCriterions["ELECTRICITY_CONSUMPTION_PER_SQM"] = "ELECTRICITY_CONSUMPTION_PER_SQM";
    ConditionCriterions["ELECTRICITY_CONSUMPTION_ENERGY_EQ"] = "ELECTRICITY_CONSUMPTION_ENERGY_EQ";
    ConditionCriterions["ELECTRICITY_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "ELECTRICITY_CONSUMPTION_ENERGY_EQ_PER_SQM";
    ConditionCriterions["ELECTRICITY_CONSUMPTION_CO2_EQ"] = "ELECTRICITY_CONSUMPTION_CO2_EQ";
    ConditionCriterions["ELECTRICITY_CONSUMPTION_CO2_EQ_PER_SQM"] = "ELECTRICITY_CONSUMPTION_CO2_EQ_PER_SQM";
    ConditionCriterions["WATER_CONSUMPTION"] = "WATER_CONSUMPTION";
    ConditionCriterions["WATER_CONSUMPTION_PER_SQM"] = "WATER_CONSUMPTION_PER_SQM";
    ConditionCriterions["WATER_CONSUMPTION_ENERGY_EQ"] = "WATER_CONSUMPTION_ENERGY_EQ";
    ConditionCriterions["WATER_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "WATER_CONSUMPTION_ENERGY_EQ_PER_SQM";
    ConditionCriterions["WATER_CONSUMPTION_CO2_EQ"] = "WATER_CONSUMPTION_CO2_EQ";
    ConditionCriterions["WATER_CONSUMPTION_CO2_EQ_PER_SQM"] = "WATER_CONSUMPTION_CO2_EQ_PER_SQM";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION"] = "COMBUSTIBLE_CONSUMPTION";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_PER_SQM";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION_ENERGY_EQ"] = "COMBUSTIBLE_CONSUMPTION_ENERGY_EQ";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION_ENERGY_EQ_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_ENERGY_EQ_PER_SQM";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION_CO2_EQ"] = "COMBUSTIBLE_CONSUMPTION_CO2_EQ";
    ConditionCriterions["COMBUSTIBLE_CONSUMPTION_CO2_EQ_PER_SQM"] = "COMBUSTIBLE_CONSUMPTION_CO2_EQ_PER_SQM";
    ConditionCriterions["ELEC_ORIGIN"] = "ELEC_ORIGIN";
    ConditionCriterions["ELEC_DESTINATION"] = "ELEC_DESTINATION";
    ConditionCriterions["COMBUSTIBLE_TYPE"] = "COMBUSTIBLE_TYPE";
    ConditionCriterions["WATER_TEMPERATURE"] = "WATER_TEMPERATURE";
    ConditionCriterions["ELEC_USE"] = "ELEC_USE";
    ConditionCriterions["WATER_USE"] = "WATER_USE";
    ConditionCriterions["COMBUSTIBLE_USE"] = "COMBUSTIBLE_USE";
})(ConditionCriterions = exports.ConditionCriterions || (exports.ConditionCriterions = {}));
var ConditionOperators;
(function (ConditionOperators) {
    ConditionOperators["IS"] = "IS";
    ConditionOperators["IS_EQUAL"] = "IS_EQUAL";
    ConditionOperators["IS_NOT"] = "IS_NOT";
    ConditionOperators["IS_NOT_EQUAL"] = "IS_NOT_EQUAL";
    ConditionOperators["IS_BETWEEN"] = "IS_BETWEEN";
    ConditionOperators["IS_GREATER"] = "IS_GREATER";
    ConditionOperators["IS_GREATER_OR_EQUALS"] = "IS_GREATER_OR_EQUALS";
    ConditionOperators["IS_LOWER"] = "IS_LOWER";
    ConditionOperators["IS_LOWER_OR_EQUALS"] = "IS_LOWER_OR_EQUALS";
    ConditionOperators["IS_EMPTY"] = "IS_EMPTY";
    ConditionOperators["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
    ConditionOperators["CONTAINS"] = "CONTAINS";
    ConditionOperators["NOT_CONTAINS"] = "NOT_CONTAINS";
    ConditionOperators["STARTS_WITH"] = "STARTS_WITH";
    ConditionOperators["ENDS_WITH"] = "ENDS_WITH";
})(ConditionOperators = exports.ConditionOperators || (exports.ConditionOperators = {}));
var FilterOperators;
(function (FilterOperators) {
    FilterOperators["AND"] = "AND";
    FilterOperators["OR"] = "OR";
    FilterOperators["AND_NOT"] = "AND_NOT";
    FilterOperators["OR_NOT"] = "OR_NOT";
})(FilterOperators = exports.FilterOperators || (exports.FilterOperators = {}));
var KpiRetailQueryTarget;
(function (KpiRetailQueryTarget) {
    KpiRetailQueryTarget["ZONE"] = "zone";
    KpiRetailQueryTarget["PASSAGE"] = "passage";
    KpiRetailQueryTarget["DEVICE"] = "device";
})(KpiRetailQueryTarget = exports.KpiRetailQueryTarget || (exports.KpiRetailQueryTarget = {}));
/**
 * @deprecated Will be removed in the future
 */
var KpiRetailQueryTargetPassageType;
(function (KpiRetailQueryTargetPassageType) {
    KpiRetailQueryTargetPassageType["ALL"] = "all";
    KpiRetailQueryTargetPassageType["EXTERIOR"] = "exterior";
    KpiRetailQueryTargetPassageType["NON_EXTERIOR"] = "nonExterior";
})(KpiRetailQueryTargetPassageType = exports.KpiRetailQueryTargetPassageType || (exports.KpiRetailQueryTargetPassageType = {}));
var PhysicalInformationFilters;
(function (PhysicalInformationFilters) {
    PhysicalInformationFilters["ZONE_ID"] = "zoneId";
    PhysicalInformationFilters["PASSAGE_ID"] = "passageId";
    PhysicalInformationFilters["DEVICE_ID"] = "deviceId";
})(PhysicalInformationFilters = exports.PhysicalInformationFilters || (exports.PhysicalInformationFilters = {}));
var MongoQueryRequiredKeys;
(function (MongoQueryRequiredKeys) {
    MongoQueryRequiredKeys["AND"] = "$and";
    MongoQueryRequiredKeys["OR"] = "$or";
})(MongoQueryRequiredKeys = exports.MongoQueryRequiredKeys || (exports.MongoQueryRequiredKeys = {}));
